import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import { createDecorator } from 'vue-class-component';

export default function DeepCopy(from: string) {
  return (target: Vue, propName: string) => {
    createDecorator((componentOptions) => {
      (componentOptions.mixins || (componentOptions.mixins = [])).push({
        data: function() {
          return {
            [propName]: null,
          };
        },
        watch: {
          [from]: {
            handler: function(value) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (this as any)[propName] = cloneDeep(value);
            },
            immediate: true,
            deep: true,
          },
        },
      });
    })(target, propName);
  };
}
